/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaStreamCastIcon16Light } from './MediaStreamCastIcon16Light';
import { MediaStreamCastIcon16Regular } from './MediaStreamCastIcon16Regular';
import { MediaStreamCastIcon16Solid } from './MediaStreamCastIcon16Solid';
import { MediaStreamCastIcon20Light } from './MediaStreamCastIcon20Light';
import { MediaStreamCastIcon20Regular } from './MediaStreamCastIcon20Regular';
import { MediaStreamCastIcon20Solid } from './MediaStreamCastIcon20Solid';
import { MediaStreamCastIcon24Regular } from './MediaStreamCastIcon24Regular';
import { MediaStreamCastIcon24Solid } from './MediaStreamCastIcon24Solid';
import { MediaStreamCastIcon32Regular } from './MediaStreamCastIcon32Regular';
import { MediaStreamCastIcon64Regular } from './MediaStreamCastIcon64Regular';
var sizes = {
    16: {
        light: MediaStreamCastIcon16Light,
        regular: MediaStreamCastIcon16Regular,
        solid: MediaStreamCastIcon16Solid,
    },
    20: {
        light: MediaStreamCastIcon20Light,
        regular: MediaStreamCastIcon20Regular,
        solid: MediaStreamCastIcon20Solid,
    },
    24: {
        regular: MediaStreamCastIcon24Regular,
        solid: MediaStreamCastIcon24Solid,
    },
    32: {
        regular: MediaStreamCastIcon32Regular,
    },
    64: {
        regular: MediaStreamCastIcon64Regular,
    },
};
export var MediaStreamCastIcon = forwardRef('MediaStreamCastIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
